// Node imports
import { dispatcher, IEvent, ingenuity } from "@quest/base-core/dist";
import { BehaviorCoreModule, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";
import { BaseGameState } from "@quest/murka-games-behavior-leopard/dist/Game/State/BaseGameState";

// Class imports
import { StackSymbolFeatureViewBG } from "../StackFeatureBG/StackSymbolFeatureViewBG";
import { StackSymbolFeatureControllerBG } from "../StackFeatureBG/StackSymbolFeatureControllerBg";
import { DisplayObject } from "pixi.js-legacy";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { MagicPotionFeatureView } from "../MagicPotionBaseGame/MagicPotionFeatureView";
import { MagicPotionFeatureController } from "../MagicPotionBaseGame/MagicPotionFeatureController";
import { JackpotBannerView } from "../JackpotBannerPresentation/JackpotBannerView";
import { JackpotBannerController } from "../JackpotBannerPresentation/JackpotBannerController";
import { TopLogoViewGame } from "../TopLogo/TopLogoViewGame";
import { TopLogoControllerGame } from "../TopLogo/TopLogoControllerGame";
import { SlotEventConstants } from "@quest/slot-core";
import { FreePlayViewGame } from "../FreePlay/FreePlayViewGame";
import { FreePlayController } from "@quest/murka-games-behavior-leopard/dist/Game/FreePlay/FreePlayController";
import { GameParserModel } from "../Platform/GameParserModel";
export class BaseGameStateAT extends BaseGameState {
  private magicPotionFeatureView: MagicPotionFeatureView;
  protected magicPotionFeatureController: MagicPotionFeatureController;
  private jackpotBannerView: JackpotBannerView;
  protected jackpotBannerController: JackpotBannerController;

  // Stack feature
  private stackSymbolView: StackSymbolFeatureViewBG;
  protected stackSymbolController: StackSymbolFeatureControllerBG;

  private freePlayViewGame: FreePlayViewGame;
  private freePlayControllerGame: FreePlayController;

  /**
   * Method overrided to subscribe game specific events
   */
  protected subscribeEventsGame(): void {
    super.subscribeEventsGame();
    dispatcher.on(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE, this.initializeStackSymbolFeature, this);
    dispatcher.on(eventDispatchers.INITIALIZE_JACKPOT_PRESENTATION, this.initializeJackpotPresentation, this);
    dispatcher.on(eventDispatchers.INITIALIZE_MAGIC_POTION_BG, this.initializeMagicPotionFeature, this);
    dispatcher.on(eventDispatchers.INITIALIZE_FREE_PLAY_ON_GAME, this.initializeFreePlayGame, this);
  }

  /**
   * Method overrided to unsubscribe game specific events
  */
  protected unSubscribeEvents(): void {
    super.unSubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_BASEGAME_STACK_FEATURE, this.initializeStackSymbolFeature, this);
    dispatcher.off(eventDispatchers.INITIALIZE_JACKPOT_PRESENTATION, this.initializeJackpotPresentation, this);
    dispatcher.off(eventDispatchers.INITIALIZE_MAGIC_POTION_BG, this.initializeMagicPotionFeature, this);
    dispatcher.off(eventDispatchers.INITIALIZE_FREE_PLAY_ON_GAME, this.initializeFreePlayGame, this);
  }

  //Intialize stack symbol
  private initializeStackSymbolFeature(): void {
    if (!this.stackSymbolView) {
      this.stackSymbolView = new StackSymbolFeatureViewBG(
        ingenuity.currentGame.cache.getJSON(
          SlotConstantsBehavior.MAIN_DATA
        ).stackSymBG
      );
      this.stackSymbolController = new StackSymbolFeatureControllerBG(
        this.stackSymbolView
      );
      this.setLayering(this.stackSymbolView, true);
    }
  }

  /**
   * This method is use to initialize magic potion feature
   */
  private initializeMagicPotionFeature(): void {
    this.magicPotionFeatureView = new MagicPotionFeatureView(
      ingenuity.currentGame.cache.getJSON(
        SlotConstantsBehavior.MAIN_DATA
      ).magicPotion
    );
    this.magicPotionFeatureController = new MagicPotionFeatureController(
      this.magicPotionFeatureView
    );
    this.setLayering(this.magicPotionFeatureView, false);
  }

  /**
   * This method is use to initialize the jackpot feature in game
   */
  private initializeJackpotPresentation(): void {
    if (!this.jackpotBannerView) {
      this.jackpotBannerView = new JackpotBannerView(
        ingenuity.currentGame.cache.getJSON(
          SlotConstantsBehavior.MAIN_DATA
        ).jackpotBanner
      );
      this.jackpotBannerController = new JackpotBannerController(
        this.jackpotBannerView
      );
      ingenuity.currentGame.stage.addChildAt(
        this.jackpotBannerView,
        ingenuity.currentGame.stage.children.length - 1
      );
    }
  }

  //set layering below winboxes
  private setLayering(obj: any, isStack: boolean) {
    const winBoxIndex: number = this.getWinBoxIndex(isStack);
    winBoxIndex && this.winReelpanel.addChildAt(obj, winBoxIndex);
  }

  //to get winBox Container Index
  //If "isStack" is true, then it will get view by index and will directly return the index of it
  private getWinBoxIndex(isStack: boolean): number {
    let winBoxContainer: number | DisplayObject;
    //If it is a stack, then get the magic potion view index so that we can add the stach view below to it
    if (isStack) {
      winBoxContainer = this.winReelpanel.getChildIndex(this.magicPotionFeatureView);
    } else {
      winBoxContainer = this.winReelpanel.getChildByName("winboxContainer");
    }
    //If it is a stack, then return the index of magic pot view so that we can add stack feature add below to pot view
    if (winBoxContainer && isStack) {
      return winBoxContainer as number;
    } else {
      return this.winReelpanel.getChildIndex(winBoxContainer as DisplayObject);
    }
  }

  // Overrided to initialize top logo 
  protected initializeGameLogoView() {
    if (!this.topLogoView) {
      this.topLogoView = new TopLogoViewGame(ingenuity.assetsData.getJSONById(SlotConstantsBehavior.MAIN_DATA).topLogo, this.view);
      new TopLogoControllerGame(this.topLogoView);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO);
    }
  }

  // this method is used to initialize free play
  private initializeFreePlayGame(): void {
    if ((ingenuity.parserModel as GameParserModel).getPromotionalFreeGame()) {
      this.freePlayViewGame = new FreePlayViewGame(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).freePlay);
      this.freePlayControllerGame = new BehaviorCoreModule.FreePlayController(this.freePlayViewGame);
      this.freePlayControllerGame.initialize();
      dispatcher.fireEvent(eventDispatchers.SET_FREEPLAY_VIEW_LAYERING, this.freePlayViewGame);
      dispatcher.fireEvent(SlotEventConstants.DISABLE_BUTTON, ingenuity.configData.promoFreePlaysBtnList);
    }
  }

  //overriden to destroy the game specific class instead of the behaviour one
  protected destroyFreePlay(): void {
    this.freePlayControllerGame.destroy();
  }

  protected freePlayViewShowHide(evt: IEvent): void {
    if (evt.data)
            this.freePlayViewGame.show();
        else
            this.freePlayViewGame.hide();
  }
}
